import * as React from "react";
const SvgButtonExpand = (props) => /* @__PURE__ */ React.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	"xmlns:svgjs": "http://svgjs.com/svgjs",
	viewBox: "0 0 24 24",
	width: 24,
	height: 24,
	...props
}, /* @__PURE__ */ React.createElement("title", null, "Exported from Streamline App (https://app.streamlineicons.com)"), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,0)" }, /* @__PURE__ */ React.createElement("path", {
	d: "M 6,17.998l-5.25,5.25 ",
	stroke: "#000000",
	fill: "none",
	strokeWidth: 1.5,
	strokeLinecap: "round",
	strokeLinejoin: "round"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M 23.25,6.748v-6h-6 ",
	stroke: "#000000",
	fill: "none",
	strokeWidth: 1.5,
	strokeLinecap: "round",
	strokeLinejoin: "round"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M 0.75,17.248v6h6 ",
	stroke: "#000000",
	fill: "none",
	strokeWidth: 1.5,
	strokeLinecap: "round",
	strokeLinejoin: "round"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M 23.25,0.748L18,5.998 ",
	stroke: "#000000",
	fill: "none",
	strokeWidth: 1.5,
	strokeLinecap: "round",
	strokeLinejoin: "round"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M 18,17.998l5.25,5.25 ",
	stroke: "#000000",
	fill: "none",
	strokeWidth: 1.5,
	strokeLinecap: "round",
	strokeLinejoin: "round"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M 0.75,6.748v-6h6 ",
	stroke: "#000000",
	fill: "none",
	strokeWidth: 1.5,
	strokeLinecap: "round",
	strokeLinejoin: "round"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M 23.25,17.248v6h-6 ",
	stroke: "#000000",
	fill: "none",
	strokeWidth: 1.5,
	strokeLinecap: "round",
	strokeLinejoin: "round"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M 0.75,0.748L6,5.998 ",
	stroke: "#000000",
	fill: "none",
	strokeWidth: 1.5,
	strokeLinecap: "round",
	strokeLinejoin: "round"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M 9,8.248h6c0.414,0,0.75,0.336,0.75,0.75v6 c0,0.414-0.336,0.75-0.75,0.75H9c-0.414,0-0.75-0.336-0.75-0.75v-6C8.25,8.584,8.586,8.248,9,8.248z",
	stroke: "#000000",
	fill: "none",
	strokeWidth: 1.5,
	strokeLinecap: "round",
	strokeLinejoin: "round"
})));
export { SvgButtonExpand as ReactComponent };
